import React from 'react'

// View wallets by account

const AccountsPage = () => {
	return (
		<div>
			<h1>Manage your accounts</h1>
		</div>
	)
}

export default AccountsPage
